import { useState, useEffect, useCallback } from "react";
import SubHeaderBoxGray from "../../components/SubHeaderBoxGray";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getOutgoingTransportSubcategory,
  updateOutgoingTransportSubcategory,
  deleteOutgoingTransportSubcategory,
  createOutgoingTransportSubcategory,
} from "../../../../../apis/Business/OutgoingTransportApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import OutgoingTransportTable from "./Table";
import SystemBoundary from "../../components/HeaderBox/SystemBoundary";
import deliveriesIcon from "../../../../../assets/design-revamp-company/company-detail-headers/deliveries-to-us-icon.svg";
import transportDeliveryIcon from "../../../../../assets/design-revamp-company/category-icons/transport_deliveries_icon.svg";
const OutgoingTransport = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const [systemBoundaryOutgoing, setSystemBoundaryOutgoing] = useState();
  const key = "add-new-outgoing-subcategory";
  const deleteKey = "delete-outgoing-subcategory";

  useEffect(() => {
    getOutgoingTransportSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateOutgoingTransportSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createOutgoingTransportSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getOutgoingTransportSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteOutgoingTransportSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <SubHeaderBoxGray
        title={t("OUTGOING_TRANSPORT")}
        scope={t("OUTGOING_TRANSPORT_SCOPE")}
        description={t("OUTGOING_TRANSPORT_DESC")}
        scopes={[{ scope: t("Scope 3"), filled: true }]}
        graphicIcons={[{ icon: deliveriesIcon }]}
        icon={transportDeliveryIcon}
        number="4.2"
        isNormal={true}
      />
      <SystemBoundary
        businessId={businessId}
        systemBoundary={systemBoundaryOutgoing}
        setSystemBoundary={setSystemBoundaryOutgoing}
        totalObjCategory="Outgoing Transport"
        customStyles={{ marginTop: "10px" }}
        isTransportDelivery={true}
      />

      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createOutgoingTransportSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={false}
                  isNormal={false}
                  baseSequence={"4.2."}
                  index={index}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />
                {showTable === sub.id && (
                  <OutgoingTransportTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategory_description={sub.description}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default OutgoingTransport;
